// extracted by mini-css-extract-plugin
export default {"view":"md-icon_view--EUOoN","size18":"md-icon_size18--tnXdj","size20":"md-icon_size20--yneWg","size36":"md-icon_size36--Y05jq"};